export default "__VITE_ASSET__dqKP7voA__"